export default __webpack_public_path__ + "static-front/media/AnketaIcon.77954460.svg";